import { gql, useQuery } from '@apollo/client';
import React from 'react';
import { useDispatch } from 'react-redux';
import Card, { Cards } from '../../components/Card';
import EmptyState from '../../components/EmptyState';
import LoadingIndicator from '../../components/LoadingIndicator';
import type {
  UserTemplatesSettingsQuery,
  UserTemplatesSettingsQueryVariables,
} from '../../graphql/generated/graphqlTypes';
import SettingsContainerView from '../../settings/SettingsContainerView';
import TemplateIcon from '../../templates/TemplateIcon';
import UIActions from '../../ui/UIActions';
import isSize from '../../utils/responsive/isSize';
import Sizes from '../../utils/responsive/Sizes';
import UserTemplatesSettingsModal from './UserTemplatesSettingsModal';
import styles from './UserTemplatesSettingsView.module.scss';

const USER_TEMPLATES_SETTINGS_QUERY = gql`
  query userTemplatesSettings {
    session: currentSession {
      user {
        id
        templates {
          id
          title
        }
      }
    }
  }
`;

const UserTemplatesSettingsView = () => {
  const dispatch = useDispatch();
  const { data: { session } = {} } = useQuery<
    UserTemplatesSettingsQuery,
    UserTemplatesSettingsQueryVariables
  >(USER_TEMPLATES_SETTINGS_QUERY);

  const inner =
    session &&
    (session.user.templates.length > 0 ? (
      <>
        <Cards>
          {session.user.templates.map((template) => (
            <Card
              key={template.id}
              onClick={() =>
                dispatch(
                  UIActions.openModal(UserTemplatesSettingsModal, {
                    id: template.id,
                    disableOutsideClose: true,
                  }),
                )
              }
            >
              <div className={styles.row}>
                <div className={styles.iconContainer}>
                  <TemplateIcon />
                </div>
                {template.title}
              </div>
            </Card>
          ))}
        </Cards>
        <div className={styles.hint}>
          To create a new template, select Templatize from the post dropdown
          menu.
        </div>
      </>
    ) : (
      <Card>
        <EmptyState
          imageName="connections"
          title="No templates yet…"
          message="To create a new template, select Templatize from the post dropdown menu."
          vertical={!isSize(Sizes.LG)}
        />
      </Card>
    ));

  return (
    <SettingsContainerView
      title="Templates"
      subtitle="Manage which posts you use as templates."
    >
      {session ? inner : <LoadingIndicator />}
    </SettingsContainerView>
  );
};

export default UserTemplatesSettingsView;
